import {StatCard as StatCardShell} from 'shells/metrics/stat-card/stat-card';

import type {AiStatFragment} from 'nutshell-graphql-types';

import {getAiUsageValue, getAiUsageType, getAiUsageLimit, getAiUsageIsUnlimited} from './helpers';

interface Props {
    stat: AiStatFragment;
    index: number;
    isPrimary: boolean;
    isMonthView?: boolean;
}

export function StatCard(props: Props) {
    const isLimitStat = getAiUsageType(props.stat) === 'limit';
    const isUnlimited = getAiUsageIsUnlimited(props.stat);
    const hideLimitDenominator = isLimitStat && !isUnlimited && !props.isMonthView;

    return (
        <StatCardShell
            displayName={props.stat.displayName}
            value={getAiUsageValue(props.stat)}
            type={hideLimitDenominator ? 'text' : getAiUsageType(props.stat)}
            isPrimary={props.isPrimary && props.index === 0}
            user={
                props.stat.__typename === 'AiUserStat' && props.stat.user
                    ? props.stat.user
                    : undefined
            }
            tooltipInfo={props.stat.tooltip ?? undefined}
            limit={hideLimitDenominator ? undefined : getAiUsageLimit(props.stat)}
            isUnlimited={hideLimitDenominator ? undefined : isUnlimited}
        />
    );
}
